export const AVATAR_NAMES: Record<string, string> = {
	'1': 'Brown Bear, Young',
	'2': 'Green Turtle, Young',
	'3': 'Penguin, Young',
	'4': 'Purple Octopus, Young',
	'5': 'Brown Bear, Teenage',
	'6': 'Green Turtle, Teenage',
	'7': 'Penguin, Teenage',
	'8': 'Purple Octopus, Teenage',
	'9': 'Giraffe, Young',
	'10': 'Blue Koala, Young',
	'11': 'Alpaca, Young',
	'12': 'Panda, Young',
	'13': 'Giraffe, Teenage',
	'14': 'Blue Koala, Teenage',
	'15': 'Alpaca, Teenage',
	'16': 'Panda, Teenage',
	'17': 'Red Fox, Young',
	'18': 'Red Fox, Teenage',
}

export const getAvatarName = (id: string): string => {
	return AVATAR_NAMES[id] || `Avatar ${id}`
}